import React from "react";
import { HCPDocumentsAndTasksView } from "src/components/portal/views/HCPDashboardLayout/HCPDocumentsView/HCPDocumentsAndTasksView";
import { FPSiteMap } from "src/components/portal/views/FPDashboardLayout/FPSiteMapView/FPSiteMap";
import { HCPBudget } from "src/components/portal/views/HCPDashboardLayout/HCPBudgetView/HCPBudget";
import { HCPGreeting } from "src/components/portal/views/HCPDashboardLayout/HCPGreetingView/HCPGreeting";
import { HCPModelHomeTour } from "src/components/portal/views/HCPDashboardLayout/HCPModelHomeTour/HCPModelHomeTour";
import { useDynamicValue, fullColumnWidths } from "src/components/_shared/hooks/useDynamicValue";
import { PrimaryHomesCalendar } from "./calendar";
import { PrimaryHomesNextStep } from "./next-step";
import { PrimaryHomesPresentationView } from "./presentation";
import { Header } from "src/0-app/1-container/header/header";
import { HCPHelpfulLinks } from "src/components/portal/views/HCPDashboardLayout/HCPHelpfulLinks/HCPHelpfulLinks";
import PrimaryHomesPhase1 from "./info";

const PrimaryHomesSummary = (props: {pageId: string | null}) => {
const {pageId} = props;
  const isPresentation = pageId === 'presentation';
  const fullWidth = useDynamicValue(fullColumnWidths);  

  if (isPresentation) {
    return <PrimaryHomesPresentationView />;
  }

  return <>
    <Header navigation_override={<></>} />
    <HCPGreeting />
    <PrimaryHomesNextStep width={fullWidth} />
    <PrimaryHomesCalendar width={fullWidth} />
    <HCPModelHomeTour width={fullWidth} />
    <FPSiteMap width={fullWidth} />
    <HCPBudget width={fullWidth} />
    <PrimaryHomesPhase1 width={fullWidth} />
    <HCPDocumentsAndTasksView width={fullWidth} />
    <HCPHelpfulLinks width={fullWidth} />
    <br />
  </>;
};

export default PrimaryHomesSummary; 